import React from 'react';
const IconUpAndDownArrows = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M12.7877 5.00841C12.3874 4.4959 11.612 4.4959 11.2116 5.00841L8.26215 8.78402C7.74926 9.44057 8.21706 10.3996 9.0502 10.3996H14.9492C15.7823 10.3996 16.2501 9.44057 15.7372 8.78402L12.7877 5.00841ZM11.2124 18.9909C11.6127 19.5034 12.3881 19.5034 12.7885 18.9909L15.7379 15.2153C16.2508 14.5587 15.783 13.5996 14.9499 13.5996L9.05093 13.5996C8.2178 13.5996 7.74999 14.5587 8.26288 15.2153L11.2124 18.9909Z" />
</svg>
);
};
export default IconUpAndDownArrows;